import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RefreshCw } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import { ref, watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableRefreshButton',
  props: {
    isFetching: { type: Boolean }
  },
  emits: ["refetch"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const isLoading = ref(false);

    watch(
        () => props.isFetching,
        (newVal, oldVal) => {
            if (oldVal === true && newVal === false) {
                isLoading.value = false;
            }
        },
    );

    const emit = __emit;

    const handleRefetch = () => {
        isLoading.value = true;
        emit('refetch');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    onClick: _withModifiers(handleRefetch, ["stop"]),
    variant: "ghost_primary",
    width: "narrow",
    class: "self-start",
    size: "xs",
    disabled: _ctx.isFetching
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('datatables.reload_table')) + " ", 1),
      _createVNode(_unref(RefreshCw), {
        class: _normalizeClass(["text-primary", { 'animate-spin': isLoading.value }])
      }, null, 8, ["class"])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})